<div class="wrapper">
  <div
    class="sidebar"
    data-color="danger"
    data-background-color="white"
    data-image="./assets/img/sidebar-1.jpg"
  >
    <app-sidebar></app-sidebar>
    <div
      class="sidebar-background"
      style="background-image: url(./assets/img/sidebar-4.jpg)"
    ></div>
  </div>

  <div class="main-panel">
    <app-navbar></app-navbar>
    <div class="example-container mat-elevation-z2" style=" margin-left: 15px; margin-right: 15px;">
      <hr />
      <div class="container-fluid  pt-2 p-bottom">
        <router-outlet></router-outlet>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</div>
